<ng-content select="[td-wb-tab-action]" />
<a href=""
   class="td-wb-tab__link"
   role="button"
   [attr.aria-pressed]="isSelected()"
   (keydown.space)="onSelect($event)"
   (click)="onSelect($event)">
  <ng-content />
</a>
<div class="td-wb-tab__select-border-left"></div>
<div class="td-wb-tab__select-indicator"></div>
